import { BaseView } from '../../../shared/utils/baseComponent'
import css from './parent.styles.scss'
import template from './parent.template.pug'

class CustomerParentController extends BaseView {
  constructor($element, $mdMedia) {
    'ngInject'
    super($element)
    Object.assign(this, { $mdMedia })
  }
}

export const customerParentComponent = {
  controller: CustomerParentController,
  template: template({ css }),
  bindings: {
    customer: '<',
  },
}



// WEBPACK FOOTER //
// ./app/customers/containers/parent/parent.component.js